export default "__VITE_ASSET__CBICWrB___"